<template>
    <div v-if="showSettingsToTable">
        <b-button v-b-tooltip.hover title="Configuraciones para la Tabla"
            variant="none" class="p-0" @click="onHandleOPenTableOptions">
            <i class="fa fa-table" :style="{ fontSize: '25px' }"></i>
        </b-button>
        <b-toast id="show-options-table" title="Configuraciones para la Tabla" static
            class="position-absolute p-2 bg-white"
            :style="{ zIndex: 10, boxShadow: '#c4c4c4 0px 0px 18px -3px' }">

                <div class="bg-light p-2 rounded w-100 mb-2">
                    <i class="fa fa-paint-brush mr-1" aria-hidden="true"></i>
                    Colores de la tabla
                </div>
            
                <b-row>
                    <!-- Color de la cabecera de la tabla -->
                    <b-col cols="3" class="mt-2">                                
                        <div class="d-flex align-items-center">
                            <b-form-input v-b-tooltip.hover title="Color del texto de la Cabecera de la Tabla" v-model="activeSection.tableHeaderColor" type="color" name="table_header_color" size="sm"></b-form-input>
                        </div>                                
                    </b-col>
                    <!-- Color del cuerpo de la tabla -->
                    <b-col cols="3" class="mt-2">                                
                        <div class="d-flex align-items-center">
                            <b-form-input v-b-tooltip.hover title="Color del texto del cuerpo de la tabla" v-model="activeSection.tableBodyColor" type="color" name="table_body_color" size="sm"></b-form-input>
                        </div>                                
                    </b-col>
                    <!-- Fondo de la cabecera de la tabla -->
                    <b-col cols="3" class="mt-2">                                
                        <div class="d-flex align-items-center">
                            <b-form-input v-b-tooltip.hover title="Color del fondo de la Cabecera de la Tabla" v-model="activeSection.tableHeaderBgColor" type="color" name="table_header_color" size="sm"></b-form-input>
                        </div>                                
                    </b-col>
                    <!-- Fondo del cuerpo de la tabla -->
                    <b-col cols="3" class="mt-2">                                
                        <div class="d-flex align-items-center">
                            <b-form-input v-b-tooltip.hover title="Color del fondo del cuerpo de la tabla" v-model="activeSection.tableBodyBgColor" type="color" name="table_body_color" size="sm"></b-form-input>
                        </div>                                
                    </b-col>
                </b-row>

                <div class="bg-light p-2 rounded w-100 mt-2">
                    <i class="fa fa-table mr-1" aria-hidden="true"></i>
                    Border de la tabla
                </div>

                <!-- Border de la tabla -->
                <b-row class="d-flex align-items-center">
                    <b-col cols="12" class="mt-2">
                        <strong>Ancho del border</strong>
                        <el-select v-model="activeSection.tableBorderWidth" name="table_border_width">
                            <el-option class="d-flex align-items-center align-items-start"
                                v-for="x in border.widths" :key="x.value" :label="x.value" :value="x.value">
                                <div :style="x.preview"></div>
                                <span class="ml-2">{{ x.label }}</span>
                            </el-option>
                        </el-select>
                    </b-col>
                    <b-col cols="12" class="mt-1">
                        <strong>Estilo del border</strong>
                        <el-select v-model="activeSection.tableBorderStyle" name="table_border_style">
                            <el-option class="d-flex align-items-center align-items-start"
                                v-for="x in border.styles" :key="x.value" :label="x.value" :value="x.value">
                                <div :style="x.preview"></div>
                                <span class="ml-2">{{ x.label }}</span>
                            </el-option>
                        </el-select>
                    </b-col>
                    <b-col cols="12" class="mt-1">
                        <strong>Color del border</strong>
                        <b-form-input v-model="activeSection.tableBorderColor" type="color" name="table_border_color"
                            size="sm"></b-form-input>
                    </b-col>
                </b-row>

                <!-- Preview de la tabla -->
                <div class="d-flex align-items-center mt-2 w-100">
                    <table class="w-100" :style="{ 
                        borderWidth: `${activeSection.tableBorderWidth}`, 
                        borderColor: activeSection.tableBorderColor, 
                        borderStyle: activeSection.tableBorderStyle,
                        borderCollapse: 'collapse'
                    }">
                        <thead>
                            <tr :style="{ backgroundColor: activeSection.tableHeaderBgColor, color: activeSection.tableHeaderColor }">
                                <th :style="{ 
                                    borderWidth: `${activeSection.tableBorderWidth}`, 
                                    borderColor: activeSection.tableBorderColor, 
                                    borderStyle: activeSection.tableBorderStyle,
                                    padding: '8px',
                                    backgroundColor: activeSection.tableHeaderBgColor, 
                                    color: activeSection.tableHeaderColor 
                                }">Columna 1</th>
                                <th :style="{ 
                                    borderWidth: `${activeSection.tableBorderWidth}`, 
                                    borderColor: activeSection.tableBorderColor, 
                                    borderStyle: activeSection.tableBorderStyle,
                                    padding: '8px',
                                    backgroundColor: activeSection.tableHeaderBgColor, 
                                    color: activeSection.tableHeaderColor 
                                }">Columna 2</th>
                                <th :style="{ 
                                    borderWidth: `${activeSection.tableBorderWidth}`, 
                                    borderColor: activeSection.tableBorderColor, 
                                    borderStyle: activeSection.tableBorderStyle,
                                    padding: '8px',
                                    backgroundColor: activeSection.tableHeaderBgColor, 
                                    color: activeSection.tableHeaderColor 
                                }">Columna 3</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr :style="{ backgroundColor: activeSection.tableBodyBgColor, color: activeSection.tableBodyColor }">
                                <td>Fila 1</td>
                                <td>Fila 2</td>
                                <td>Fila 3</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <b-button variant="dark" class="p-1 mt-2 text-white" size="sm" block
                    @click="$bvToast.hide('show-options-table')">
                    cerrar <i class="fa fa-check ml-1"></i>
                </b-button>

        </b-toast>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'TableSettings',
    
    computed: {
        ...mapState('labelDesigner', [
            'activeSection',
            'border'
        ]),

        showSettingsToTable() {
            return this.activeSection && this.activeSection.code === 'TABLE_COMPONENTS'
        }
    },

    methods: {
        onHandleOPenTableOptions() {
            this.$bvToast.show('show-options-table')
        }
    }
}
</script> 